<template>
	<v-layout
		wrap
		justify-space-around
		align-center
		:class="[border, { 'gray-color': gray }, `${withoutBackground ? '' : 'white'}` ]"
	>
		<v-flex xs2 v-if="viewLegend">
			<v-layout
				wrap
				align-center
				:style="`border-right:1px solid ${$appColors.gray};`"
			>
				<v-flex xs12 v-for="(item, index) in legends" :key="index" py-2>
					<template v-if="average && index > 0">
						<span
							:style="`background-color: ${item.color}`"
							class="color-legend color-legend-average"
						>
							<span
								class="text-big-gray"
								:style="`color:${$appColors.info}`"
							>
								{{ item.name }}: {{ average[0] }}
							</span>
						</span>
					</template>
					<template v-else>
						<span
							:style="`background-color: ${item.color}`"
							class="color-legend"
						></span>
						<span
							class="text-big-gray"
							:style="`color:${$appColors.info}`"
						>
							{{ item.name }}
						</span>
					</template>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex :class="`${!viewLegend ? 'xs12' : 'xs10'}`">
			<v-layout
				wrap align-center
				:style="`border:1px solid ${viewApplicants ? $appColors.gray : 'transparent'};`"
			>
				<v-flex v-if="viewApplicants" class="container-diagnosis" text-xs-center>
					<v-btn
						color="secondary"
						class="btn-image"
						@click="openApplicants"
					>
						<img src="/static/img/diagnosis/applicants.svg" alt="applicants" class="mr-1">
						<span class="number-bold">{{ applicants }} / {{totalApplicants}}</span>
						<span class="text-small">Aplicantes</span>
					</v-btn>
				</v-flex>
				<v-flex
					v-for="(item, index) in row"
					:key="index"
					:class="[
						'container-diagnosis',
						{ 'no-display': item.code },
					]"
					:style="`color: ${$appColors.primary}`"
				>
					<v-layout
						class="container-diagnosis-wrap"
						wrap align-center justify-center
					>
						<template v-if="item.image">
							<img
								class="flex xs12 lg3 text-xs-center"
								:src="item.image"
								:alt="item.description"
								height="27"
							/>
						</template>
						<v-flex xs12 lg4 text-xs-center v-if="item.textBlue">
							<span
								class="text-blue"
								:style="`color:${$appColors.primary}`"
							>
								{{ item.textBlue }}
							</span>
						</v-flex>
						<v-flex xs12 lg3 text-xs-center>
							<span
								class="number-diagnosis"
								:style="`color:${$appColors.info}`"
								v-if="!!item.code">{{ item.number || 0 }}</span>
							<span
								class="number-diagnosis"
								:style="`color:${$appColors.info}`"
								v-else>{{ item.number }}/{{ item.numberTotal }}</span>
						</v-flex>
						<v-flex
							xs12 text-xs-center
							:class="`${item.image ? 'lg6' : 'lg5'} ${legendBorderRight && (index < (row.filter(r => !r.code).length - 1)) ? 'border-right-blue' : ''}`"
						>
							<span
								:style="`color:${$appColors.info}`"
								class="description"
							>{{ item.description }}</span>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
function openApplicants() {
	this.$emit('open-applicants');
}

export default {
	name: 'row-graphic',
	methods: {
		openApplicants,
	},
	props: {
		applicants: [Number, String],
		average: {
			default: () => [],
			type: Array,
		},
		border: {
			type: Boolean,
			default: true,
		},
		gray: {
			type: Boolean,
			default: false,
		},
		legends: {
			type: Array,
			default: () => [],
		},
		legendBorderRight: {
			default: false,
			type: Boolean,
		},
		row: {
			default: () => [],
			type: Array,
		},
		totalApplicants: [Number, String],
		viewApplicants: {
			type: Boolean,
			default: false,
		},
		viewLegend: {
			type: Boolean,
			default: false,
		},
		withoutBackground: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.number-diagnosis {
	font-size: 12px;
	font-weight: bold;
}

.description {
	font-size: size(xsmall);
}

.container-diagnosis {
	align-items: center;
	position: relative;

	&:last-child {
		&::before {
			content: none;
		}
	}
}

.text-blue {
	display: inline-block;
	font-size: size(xsmall);
	font-weight: bold;
	max-width: 54px;
}

.border {
	border: 1px solid color(border-gray);
}

.gray-color {
	background: transparent;
}

.btn-image {
	border-radius: 13px;
	box-shadow: none !important;
	color: color(white) !important;
	height: 27px;
	margin: 0;
	text-transform: none !important;
	width: 158px !important;
}

.number-bold {
	font-family: font(bold);
	font-size: size(large);
	margin-right: 4px;
}

.text-small {
	font-size: size(xsmall);
}

.wrapper-btn {
	padding: 0 15px 0 0px;
	position: relative;

	&::before {
		background: color(primary);
		bottom: 0;
		content: '';
		height: 19px;
    	position: absolute;
		right: 0;
    	top: 4px;
    	width: 2px;
	}
}

.color-legend {
	display: inline-block;
	height: 19px;
	margin-right: 4px;
	vertical-align: middle;
	width: 19px;

	&-average {
		align-items: center;
		border-radius: 13.5px;
		display: flex;
		height: 27px;
		justify-content: center;
		width: 108px;

		.text-big-gray {
			color: color(white) !important;
		}
	}
}

.text-big-gray {
	font-size: size(medium);
}

.alig-center {
	align-items: center;
	display: flex;
}

.no-display {
	display: none;
}

.border-right-blue {
	border-right: 2px solid #f09c2b;
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/action-one/row-graphic.vue